/* eslint-disable camelcase, @typescript-eslint/naming-convention */
import { SongType } from 'services/api/entities';
import { ReleaseSongStatus } from 'services/api/entities/distribution/release';
import { ReleaseSongResponse } from 'services/api/responses/responseTypes';

export const getSongStatus = (
  songResponse: ReleaseSongResponse,
  songType: SongType
) => {
  const { title, metadata } = songResponse;
  if (!title) {
    return ReleaseSongStatus.WARNING;
  }

  if (songType === SongType.USER_UPLOADED) {
    if (!metadata) {
      return ReleaseSongStatus.WARNING;
    }
    const { composer, has_vocals, vocals_content, language } = metadata;

    if (!composer || (has_vocals && (!vocals_content || !language))) {
      return ReleaseSongStatus.WARNING;
    }
  }
  return ReleaseSongStatus.VALID;
};
